function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M79.093 0L48.907 30.187 146.72 128l-97.813 97.813L79.093 256l128-128z"
});

function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTYgMjU2IiB3aWR0aD0iMjU2IiBoZWlnaHQ9IjI1NiI+CiAgPHBhdGggZD0iTTc5LjA5MyAwbC0zMC4xODYgMzAuMTg3IDk3LjgxMyA5Ny44MTMtOTcuODEzIDk3LjgxMyAzMC4xODYgMzAuMTg3IDEyOC0xMjh6Ii8+Cjwvc3ZnPgo=";
export { SvgChevronRight as ReactComponent };